import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {SavedAccountIdentityProps} from './saved-account-identity.types';
import {InitialsAvatar} from '../initials-avatar/initials-avatar';
import styles from './saved-account-identity.module.scss';

/** An account's avatar, name and email — the row content in the chooser and remove mode. */
export function SavedAccountIdentity({account, avatarSize}: SavedAccountIdentityProps): ReactElement {
  return (
    <div className={styles.identity}>
      <InitialsAvatar colourSlot={account.colourSlot} name={account.name} size={avatarSize} />
      <div className={styles.texts}>
        <Text bold className={styles.name} size={TextSize.MD} val={account.name} />
        <Text className={styles.email} size={TextSize.MD} val={account.email} />
      </div>
    </div>
  );
}
